webpackJsonp([0],{

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SlantedPanel = exports.SectionPanel = exports.SectionImage = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(138);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Section = _react2.default.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      children = _ref.children,
      theme = _ref.theme;
  return _react2.default.createElement(
    "section",
    { ref: ref, className: "section " + className + " " + (theme ? "section--" + theme : "") },
    children
  );
});

var SectionImage = exports.SectionImage = function SectionImage(_ref2) {
  var src = _ref2.src;
  return _react2.default.createElement("div", {
    className: "section__image",
    style: { backgroundImage: "url(" + src + ")" }
  });
};

var SectionPanel = exports.SectionPanel = function SectionPanel(_ref3) {
  var children = _ref3.children,
      right = _ref3.right,
      _ref3$slanted = _ref3.slanted,
      slanted = _ref3$slanted === undefined ? false : _ref3$slanted,
      width = _ref3.width;

  var classNames = "section__panel";

  if (right) classNames += " section__panel--right";
  if (slanted) classNames += " section__panel--slanted";

  return _react2.default.createElement(
    "div",
    { className: "section__content", style: { width: width || null } },
    _react2.default.createElement(
      "div",
      { className: classNames },
      children
    )
  );
};

var SlantedPanel = exports.SlantedPanel = function SlantedPanel(_ref4) {
  var _ref4$className = _ref4.className,
      className = _ref4$className === undefined ? "" : _ref4$className,
      _ref4$direction = _ref4.direction,
      direction = _ref4$direction === undefined ? "left" : _ref4$direction,
      children = _ref4.children;
  return _react2.default.createElement(
    "div",
    { className: "slanted-panel slanted-panel--" + direction + " " + className },
    _react2.default.createElement(
      "div",
      { className: "section__content" },
      children
    )
  );
};

exports.default = Section;

/***/ }),

/***/ 138:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Hero = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(140);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hero = exports.Hero = function Hero(_ref) {
  var heading = _ref.heading,
      subheading = _ref.subheading,
      _ref$image = _ref.image,
      image = _ref$image === undefined ? "" : _ref$image,
      large = _ref.large;
  return _react2.default.createElement(
    "div",
    { className: "hero " + (large ? "hero--large" : "") },
    _react2.default.createElement(
      "div",
      { className: "hero-image-wrapper" },
      _react2.default.createElement("div", {
        className: "hero-image",
        style: { backgroundImage: "url(" + image + ")" }
      })
    ),
    _react2.default.createElement(
      "div",
      { className: "hero-text" },
      heading && _react2.default.createElement(
        "h1",
        { className: "hero__heading" },
        heading
      ),
      subheading && _react2.default.createElement(
        "p",
        { className: "hero__sub-heading" },
        subheading
      )
    )
  );
};

exports.default = Hero;

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(11);

__webpack_require__(142);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Button = function Button(_ref) {
  var children = _ref.children,
      _ref$type = _ref.type,
      type = _ref$type === undefined ? "primary" : _ref$type,
      position = _ref.position,
      style = _ref.style,
      to = _ref.to,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === undefined ? false : _ref$isDisabled,
      _ref$isSubmit = _ref.isSubmit,
      isSubmit = _ref$isSubmit === undefined ? false : _ref$isSubmit;

  var component = void 0;
  var buttonProps = {
    className: "button",
    style: style
  };

  if (type) buttonProps.className += " button--" + type;
  if (position) buttonProps.className += " button--" + position;
  if (isDisabled) buttonProps.className += " button--disabled";

  if (to) {
    buttonProps.to = to;
    component = _react2.default.createElement(
      _reactStatic.Link,
      buttonProps,
      children
    );
  } else {
    component = _react2.default.createElement(
      "button",
      _extends({
        type: isSubmit ? "submit" : "button",
        disabled: isDisabled
      }, buttonProps),
      children
    );
  }

  return component;
};

exports.default = Button;

/***/ }),

/***/ 142:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(144);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PolaroidImage(props) {
  var src = props.src,
      alt = props.alt;


  return _react2.default.createElement(
    "div",
    { className: "polaroid-image" },
    _react2.default.createElement(
      "div",
      { className: "polaroid-image__container" },
      src && _react2.default.createElement("img", { src: src, alt: alt })
    )
  );
}

exports.default = PolaroidImage;

/***/ }),

/***/ 144:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/aea_medical_help.2027367d.jpg";

/***/ }),

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/haitian-school-kids.faa5e105.jpg";

/***/ }),

/***/ 147:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeartImage = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(11);

var _reactHelmet = __webpack_require__(22);

var _Section = __webpack_require__(137);

var _Section2 = _interopRequireDefault(_Section);

var _Hero = __webpack_require__(139);

var _Hero2 = _interopRequireDefault(_Hero);

var _Button = __webpack_require__(141);

var _Button2 = _interopRequireDefault(_Button);

var _PolaroidImage = __webpack_require__(143);

var _PolaroidImage2 = _interopRequireDefault(_PolaroidImage);

var _aea_medical_help = __webpack_require__(145);

var _aea_medical_help2 = _interopRequireDefault(_aea_medical_help);

var _haitianSchoolKids = __webpack_require__(146);

var _haitianSchoolKids2 = _interopRequireDefault(_haitianSchoolKids);

__webpack_require__(147);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Home = function Home(_ref) {
  var _ref$pageData = _ref.pageData,
      heading = _ref$pageData.heading,
      subheading = _ref$pageData.subheading,
      heroImageLg = _ref$pageData.heroImageLg;
  return _react2.default.createElement(
    "div",
    { className: "home" },
    _react2.default.createElement(
      _reactHelmet.Helmet,
      null,
      _react2.default.createElement(
        "title",
        null,
        "Amour En Action"
      )
    ),
    _react2.default.createElement(
      "div",
      { className: "hero-container" },
      _react2.default.createElement(_Hero2.default, {
        heading: heading,
        subheading: subheading,
        large: true,
        image: heroImageLg
      })
    ),
    _react2.default.createElement(
      _Section2.default,
      { className: "home__intro-section", theme: "light-grain" },
      _react2.default.createElement(
        _Section.SectionPanel,
        { padded: true },
        _react2.default.createElement(
          "h3",
          { className: "home__intro-heading" },
          "So We Began"
        ),
        _react2.default.createElement(
          "div",
          { className: "home__intro" },
          _react2.default.createElement(
            "p",
            null,
            "Amour En Action is a non-profit established in 1997 and is incorporated as a 501(c)(3) charitable organization. We are a Christian Organization dedicated to providing humanitarian and educational services to the needy citizens of Haiti. Our mission is to improve their living conditions while creating hope for a brighter future."
          ),
          _react2.default.createElement(
            _Button2.default,
            { to: "/about" },
            "About us"
          )
        )
      ),
      _react2.default.createElement(_PolaroidImage2.default, { src: _aea_medical_help2.default }),
      _react2.default.createElement(_PolaroidImage2.default, null)
    ),
    _react2.default.createElement(
      _Section2.default,
      null,
      _react2.default.createElement(_Section.SectionImage, { src: _haitianSchoolKids2.default }),
      _react2.default.createElement(
        _Section.SlantedPanel,
        { className: "amour-panel" },
        _react2.default.createElement(
          "div",
          { className: "amour-section" },
          _react2.default.createElement(
            "h3",
            null,
            "Love In Action"
          ),
          _react2.default.createElement(
            "ul",
            null,
            _react2.default.createElement(
              "li",
              null,
              "Building Parks"
            ),
            _react2.default.createElement(
              "li",
              null,
              "Rebuilding Schools"
            ),
            _react2.default.createElement(
              "li",
              null,
              "Rebuild Orphanages"
            ),
            _react2.default.createElement(
              "li",
              null,
              "Providing Clean Water"
            ),
            _react2.default.createElement(
              "li",
              null,
              "Building Clinics & Hospitals"
            )
          ),
          _react2.default.createElement(
            _Button2.default,
            { to: "/take-action", style: { marginLeft: 10 } },
            "Take Action"
          )
        )
      )
    ),
    _react2.default.createElement(
      _Section2.default,
      { theme: "light-grain" },
      _react2.default.createElement(
        _Section.SectionPanel,
        { padded: true },
        _react2.default.createElement(
          "h3",
          null,
          "Your Support Is Needed"
        ),
        _react2.default.createElement(
          "p",
          null,
          "Your support would assist in providing proper health care, education and humanitarian aid to the needy. Please don't delay. If you feel the need on your heart to give, please do so. Remember that no amount is too small. Thank you for your contribution and for partnering with us.",
          _react2.default.createElement("br", null),
          _react2.default.createElement(
            "span",
            { className: "highlighted" },
            "*All contributions are tax-deductible."
          )
        ),
        _react2.default.createElement(
          _Button2.default,
          { to: "/take-action", position: "center" },
          "Make a Donation"
        )
      )
    )
  );
};

var HeartImage = exports.HeartImage = function HeartImage(_ref2) {
  var src = _ref2.src,
      _ref2$pos = _ref2.pos,
      pos = _ref2$pos === undefined ? {} : _ref2$pos,
      _ref2$size = _ref2.size,
      size = _ref2$size === undefined ? {} : _ref2$size;
  return _react2.default.createElement(
    "div",
    { className: "heart-image" },
    _react2.default.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: "100%",
        viewBox: "0 0 " + (size.width || 510) + " " + (size.height || 510)
      },
      _react2.default.createElement(
        "defs",
        null,
        _react2.default.createElement(
          "clipPath",
          { id: "a" },
          _react2.default.createElement("path", {
            d: "M255 489.6l-35.7-35.7C86.7 336.6 0 257.55 0 160.65 0 81.6 61.2 20.4 140.25 20.4c43.35 0 86.7 20.4 114.75 53.55C283.05 40.8 326.4 20.4 369.75 20.4 448.8 20.4 510 81.6 510 160.65c0 96.9-86.7 175.95-219.3 293.25L255 489.6z",
            fill: "#D80027"
          })
        )
      ),
      _react2.default.createElement("image", {
        height: "100%",
        x: pos.x || 0,
        y: pos.y || 0,
        xlinkHref: src,
        preserveAspectRatio: "xMinYMid meet",
        clipPath: "url(#a)"
      })
    )
  );
};

exports.default = function () {
  return _react2.default.createElement(_reactStatic.RouteData, { component: Home });
};

/***/ })

});


// WEBPACK FOOTER //
// templates/src/pages/Home/Home.72aca8db.js